import React, { FC, useMemo } from 'react';
import { BulkEditTableProps } from './BulkEditTableProps';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import useTranslation from '../../hooks/useTranslation';
import { getTableColumns } from './utils';
import Box from '@mui/material/Box';
import skapaColours from '@ingka/variables/colours-css';

const BulkEditTable: FC<BulkEditTableProps> = ({
  projects,
  onChange,
  loading,
  userRole,
  apiRef,
  userList,
  onAddSolutionsClicked,
}) => {
  const t = useTranslation();

  const closeProject = useMemo(
    () =>
      projects.findIndex((project) => project.establishmentType === 'CLOSE'),
    [projects],
  );

  const columns = getTableColumns(
    t,
    onChange,
    userRole,
    closeProject !== -1,
    userList,
    onAddSolutionsClicked,
  );
  return (
    <Box position="relative">
      <Box sx={{ height: '70vh' }} data-testid="ppm-project-bulk">
        <DataGridPremium
          rowHeight={64}
          apiRef={apiRef}
          sx={{
            border: 0,
            '.Mui-DatagridRow-even': {
              backgroundColor: skapaColours.colourNeutral2,
            },
            '.MuiDataGrid-columnHeaderTitle': {
              color: skapaColours.colourNeutral6,
            },
            '.overflow-visible': {
              overflow: 'visible !important',
            },
            '& [class*="__menu"]': {
              backgroundColor: '#fff',
              zIndex: 4,
            },
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? 'Mui-DatagridRow-even'
              : 'Mui-DatagridRow-odd'
          }
          disableColumnMenu
          disableRowSelectionOnClick
          initialState={{
            pinnedColumns: {},
          }}
          isRowSelectable={() => false}
          onCellKeyDown={(params, event: React.KeyboardEvent) => {
            if (event.key === ' ') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              event.defaultMuiPrevented = true;
            }
            if (event.ctrlKey && event.key === 'a') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              event.defaultMuiPrevented = true;
            }
          }}
          pagination
          loading={loading}
          pageSizeOptions={[10, 25, 50, 100]}
          columns={columns as GridColDef[]}
          rows={projects}
        />
      </Box>
    </Box>
  );
};

export default BulkEditTable;
